import axios from "axios";

const API_URL = "";

const getToken = () => localStorage.getItem("authToken");

const getHeaders = (isFormData) => ({
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    Authorization: `Bearer ${getToken()}`,
});

export const get = async (url) => {
    try {
        const response = await axios.get(`${API_URL}${url}`, { headers: getHeaders() });
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};

export const post = async (url, data) => {
    const isFormData = data instanceof FormData;
    try {
        const response = await axios.post(`${API_URL}${url}`, data, { headers: getHeaders(isFormData) });
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};

export const put = async (url, data) => {
    const isFormData = data instanceof FormData;
    try {
        const response = await axios.put(`${API_URL}${url}`, data, { headers: getHeaders(isFormData) });
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};

export const del = async (url) => {
    try {
        const response = await axios.delete(`${API_URL}${url}`, { headers: getHeaders() });
        return response.data;
    } catch (err) {
        return Promise.reject(err);
    }
};
